import React from 'react';
import { Capacitor } from '@capacitor/core';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from './auth/useAuth';
import { NativeAuthProvider } from './auth/nativeAuth';
import './index.css';
import App from './App';
import { initAnalytics } from './services/analyticsService';
import { ScannedTicketsProvider } from './hooks/useScannedTickets';
import { UserPrefsProvider } from './hooks/useUserPrefs';
import { RuleBuilderPersistenceProvider } from './stores/RuleBuilderPersistenceProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ?? '';

const platform = Capacitor.getPlatform();
document.documentElement.classList.add(`chancey-platform-${platform}`);
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('chancey-platform-native');
}

initAnalytics();

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey} afterSignOutUrl="/">
      <NativeAuthProvider publishableKey={clerkPublishableKey}>
        <UserPrefsProvider>
          <RuleBuilderPersistenceProvider>
            <ScannedTicketsProvider>
              <App />
            </ScannedTicketsProvider>
          </RuleBuilderPersistenceProvider>
        </UserPrefsProvider>
      </NativeAuthProvider>
    </ClerkProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
